import { message } from "antd";

const toastConfig = {
  className: "stockbot-toast",
  duration: 2.8,
};

const showToast = (type, content) =>
  message[type]({
    ...toastConfig,
    content,
  });

export const appToast = {
  error: (content) => showToast("error", content),
  info: (content) => showToast("info", content),
  success: (content) => showToast("success", content),
  warning: (content) => showToast("warning", content),
};

export default appToast;
